import { HYDRATE } from 'next-redux-wrapper';

import { TSegmentedStory } from '@r1-frontend/api-domru/spec-offer/v1/stories/dto/responseDto';

import { InferValueTypes, THydrateAction } from '~/src/store';
import * as ActionCreators from '~/src/store/actionCreators/stories';
import { EStoriesActionTypes } from '~/src/store/actionTypes/stories';

export type TReadableStory = TSegmentedStory & {
    isRead?: boolean,
};

export interface IStoriesStore {
    isLoading: boolean,
    stories: TReadableStory[],
}

const INITIAL_STATE: IStoriesStore = {
    isLoading: true,
    stories: [],
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

const specOfferReducer = (state = INITIAL_STATE, action: TActions): IStoriesStore => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.segmentedStories };
        case EStoriesActionTypes.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case EStoriesActionTypes.SET_STORIES:
            return {
                ...state,
                stories: action.payload,
            };
        default:
            return state;
    }
};

export default specOfferReducer;
